import { render, staticRenderFns } from "./DataBuildForAnimal.vue?vue&type=template&id=68dc4cec&scoped=true&"
import script from "./DataBuildForAnimal.vue?vue&type=script&lang=js&"
export * from "./DataBuildForAnimal.vue?vue&type=script&lang=js&"
import style0 from "./DataBuildForAnimal.vue?vue&type=style&index=0&id=68dc4cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dc4cec",
  null
  
)

export default component.exports